import { apiClient } from '../client';
import { API_ENDPOINTS } from '../config';

interface SavedList {
  id: string;
  name: string;
  description?: string;
  itemCount: number;
  isShared: boolean;
  createdAt: string;
  updatedAt: string;
}

interface SavedItem {
  id: string;
  type: 'provider' | 'procedure' | 'medication';
  name: string;
  details: any;
  addedAt: string;
}

interface CreateListData {
  name: string;
  description?: string;
}

interface ShareListData {
  emails: string[];
  message?: string;
}

class SavedService {
  async getLists(): Promise<{ success: boolean; data: SavedList[] }> {
    return apiClient.get(API_ENDPOINTS.saved.lists);
  }

  async createList(data: CreateListData) {
    const response = await apiClient.post(API_ENDPOINTS.saved.createList, data);
    apiClient.clearCache(API_ENDPOINTS.saved.lists);
    return response;
  }

  async updateList(listId: string, data: Partial<CreateListData>) {
    const response = await apiClient.put(API_ENDPOINTS.saved.updateList(listId), data);
    apiClient.clearCache(API_ENDPOINTS.saved.lists);
    return response;
  }

  async deleteList(listId: string) {
    const response = await apiClient.delete(API_ENDPOINTS.saved.deleteList(listId));
    apiClient.clearCache(API_ENDPOINTS.saved.lists);
    return response;
  }

  async addItem(listId: string, item: SavedItem) {
    const response = await apiClient.post(API_ENDPOINTS.saved.addItem(listId), item);
    apiClient.clearCache(API_ENDPOINTS.saved.lists);
    return response;
  }

  async removeItem(listId: string, itemId: string) {
    const response = await apiClient.delete(API_ENDPOINTS.saved.removeItem(listId, itemId));
    apiClient.clearCache(API_ENDPOINTS.saved.lists);
    return response;
  }

  async shareList(listId: string, data: ShareListData) {
    return apiClient.post(API_ENDPOINTS.saved.share(listId), data);
  }
}

export const savedService = new SavedService();